import { Avatar, Box, Typography } from '@mui/material';
import React from 'react';
import { activityLogsStyles as styles } from './activityLogsStyles';
import { humanizeTimestamp } from '../../utility/dateUtils';
import { ActivityLog } from '../../types/ActivityLog';

interface ActivityLogTileProps {
  log: ActivityLog;
}

const ActivityLogTile: React.FC<ActivityLogTileProps> = ({ log }) => {
  return (
    <Box sx={styles.logItem}>
      <Typography sx={styles.description}>{log.description}</Typography>
      <Box sx={styles.meta}>
        <Box sx={styles.userInfo}>
          <Avatar src={log.employee_avatar_url} alt={log.employee_display_name || log.user_email} sx={{ width: 20, height: 20 }} />
          <Typography sx={styles.user}>{log.employee_display_name || log.user_email}</Typography>
        </Box>
        <Typography sx={styles.time}>{humanizeTimestamp(log.created_at)}</Typography>
      </Box>
    </Box>
  );
};

export default ActivityLogTile;
